import { useEffect, useState } from 'react';
import StepperControl from './components/StepperControl';
import Card from 'components/card';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import Checkbox from 'components/checkbox';
import Select from 'react-select';
import InputField from 'components/fields/InputField';
import { allChannels, frenchAreas } from 'variables/industries';
import { useIndustries } from 'services/industryService';
import { ChannelIcon } from 'components/icons';

const SellerOffer = () => {
    const { industries: industriesData, loading: industriesLoading } = useIndustries();
    const [currentStep, setCurrentStep] = useState(1);
    const [error, setError] = useState('');

    const [channels, setChannels] = useState([]);
    const [industry, setIndustry] = useState('Rénovation');
    const [subIndustry, setSubIndustry] = useState('Pompe à chaleur');
    const [offerCreated, setOfferCreated] = useState(false);
    const [fields, setFields] = useState([]);

    const [offer, setOffer] = useState<any>({
        type: 'leads',
        channels: [],
        industry: 'Rénovation',
        subIndustry: 'Pompe à chaleur',
        regions: ['Toute la France'],
        fields: ['prénom', 'nom', 'email', 'téléphone'],
        websiteInfo: '',
        weeklyQuantity: '',
        sellerPrice: '',
        franceOnly: true,
        //leadNbr: "",
    });

    const handlechange = (e: any) => {
        const { id, value } = e.target;

        setError('');
        if (id === 'weeklyQuantity' && Number(value) < 40) {
            setOffer({ ...offer, [id]: 40 });
            setError('La quantité minimale est de 40 leads');
        } else if (id === 'weeklyQuantity' && Number(value) > 500) {
            setOffer({ ...offer, [id]: 500 });
            setError('La quantité maximale est de 500 leads');
        } else {
            setOffer({ ...offer, [id]: value });
        }
    };

    // const getPricing: any = () => {
    //   const indus = window.localStorage.getItem('industry');
    //   if (industriesPricing[indus]) return industriesPricing[indus].pricing;
    //   return [
    //     '15-20',
    //     '20-25',
    //     '25-30',
    //     '30-35',
    //     '35-40',
    //     '40-45',
    //     '45-50',
    //     '50-55',
    //     '55-60',
    //   ];
    // };

    const handleFieldsChange = (e: any) => {
        const { id, checked } = e.target;
        let newFields = [...fields, id];
        newFields = [
            ...new Set([...newFields, ...['Téléphone', 'Nom', 'Prénom']]),
        ];

        if (checked) {
            setFields(newFields);
        } else {
            newFields = fields.filter((fields) => fields !== id);
            setFields(newFields);
        }
        let newE = {
            target: {
                id: 'fields',
                value: newFields,
            },
        };
        handlechange(newE);
    };

    const handleChannelChange = (e: any) => {
        const { id, checked } = e.target;
        let newChannels = [...channels, id];
        if (checked) {
            setChannels(newChannels);
        } else {
            newChannels = channels.filter((channel) => channel !== id);
            setChannels(newChannels);
        }
        let newE = {
            target: {
                id: 'channels',
                value: newChannels,
            },
        };
        handlechange(newE);
    };

    const handleIndustryChange = (e: any) => {
        const { value } = e.target;
        window.localStorage.setItem('industry', value);
        const selectedIndustry = industriesData.find(i => i.name === value);
        
        setIndustry(value);
        if (selectedIndustry && selectedIndustry.subIndustries.length > 0) {
            setSubIndustry(selectedIndustry.subIndustries[0].name);
            setOffer({
                ...offer,
                industry: value,
                subIndustry: selectedIndustry.subIndustries[0].name,
            });
        } else {
            setSubIndustry('');
            setOffer({
                ...offer,
                industry: value,
                subIndustry: '',
            });
        }
    };

    const handleSubIndustryChange = (e: any) => {
        const { value } = e.target;
        setSubIndustry(value);
        handlechange(e);
    };

    const handleQuickSelect = (areas: string[], label: string) => {
        // Remove "Toute la France" and "Toute la Belgique" from current regions
        const currentRegions = offer.regions.filter(
            (region: string) =>
                region !== 'Toute la France' && region !== 'Toute la Belgique'
        );

        // Add new areas to current regions, avoiding duplicates
        const newRegions = [...new Set([...currentRegions, ...areas])];

        const newE = {
            target: {
                id: 'regions',
                value: newRegions,
            },
        };
        handlechange(newE);
    };

    const handleClearAll = () => {
        const newE = {
            target: {
                id: 'regions',
                value: [] as string[],
            },
        };
        handlechange(newE);
    };

    useEffect(() => {
        window.localStorage.setItem('industry', industry);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        console.log(offer.industry, offer.subIndustry);
    }, [offer]);

    const steps = [
        { stepNo: 1, name: 'Créer une offre', error: error },
        { stepNo: 2, name: 'Pricing', error: error },
    ];

    const createOffer = () => {
        if (offerCreated) return;
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        setOfferCreated(true);
        axios
            .post(`${CONFIG.apiUrl}/seller-offer`, offer, config)
            .then((res: any) => {
                window.location.href = '/admin/my-offer?created=true';
            })
            .catch((err: any) => {
                setError(err.response.data.error);
                setOfferCreated(false);
            });
    };

    const handleClick = (direction: string) => {
        console.log(offer);
        let newStep = currentStep;

        direction === 'next' ? newStep++ : newStep--;
        // check if steps are within bounds
        if (newStep > 0 && newStep <= steps.length) {
            const hasCountryWideSelection = offer.regions.some((region: string) =>
                region.includes('Toute')
            );
            const hasClimateZone = offer.regions.some((region: string) =>
                region.includes('Zone Climatique')
            );

            if (
                offer.regions.length < 7 &&
                !hasCountryWideSelection &&
                !hasClimateZone
            ) {
                setError(
                    'Si vous opérez sur moins de 7 départements ou si vous souhaitez passer une commande inférieure à 40 leads, nous vous recommandons de procéder via un ordre d’achat.'
                );
                return;
            }
            if (offer.channels.length > 0) setCurrentStep(newStep);
            else setError('Veuillez remplir tous les champs obligatoires');
        }
        if (newStep === 3) {
            console.log('submit');
            createOffer();
        }
    };

    if (industriesLoading) {
        return (
            <div className="mt-3 h-full w-full">
                <div className="flex h-screen items-center justify-center">
                    <div className="text-xl font-bold text-navy-700 dark:text-white">
                        Chargement des industries...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="mt-3 h-full w-full">
            <div className="absolute z-10 ml-10 mt-2 items-center text-center font-poppins text-[26px] font-bold uppercase text-white">
                Leadrs.co
            </div>
            <div className="absolute z-10 ml-10 mt-10 items-center text-center font-poppins text-[14px] font-bold text-white">
                Ajouter une offre
            </div>

            <div className="z-0 h-[00px] w-full rounded-[20px] bg-gradient-to-br from-brandLinear to-blueSecondary md:h-[300px]" />
            <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
                <div className="-mt-[280px] w-full pb-10 md:-mt-[240px] md:px-[70px]"></div>
                <Card extra={'h-full mx-auto pb-3'}>
                    <div className="rounded-[20px]">
                        {/* Stepper One */}
                        <div
                            className={`${
                                steps[currentStep - 1].stepNo === 2 && 'hidden'
                            } h-full w-full rounded-[20px] px-3 pt-7 md:px-8`}
                        >
                            {/* Header */}
                            <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
                                Créer une offre
                            </h4>

                            {/* Error message */}
                            {error && (
                                <div className="z-10 ml-1 mt-2 items-center font-poppins text-[14px] text-red-500">
                                    {error}.
                                </div>
                            )}

                            {/* content */}
                            {/* inputs */}
                            <div className="mt-6 grid grid-cols-2 gap-3">
                                <div className="col-span-2 md:col-span-1">
                                    {/* Type */}
                                    <div className="mb-0 mt-4">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Départements*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <Select
                                                value={offer.regions.map(
                                                    (region: string) => ({
                                                        value:
                                                            region ===
                                                            'Toute la France'
                                                                ? 'france'
                                                                : region,
                                                        label: region,
                                                    })
                                                )}
                                                isMulti
                                                onChange={(items) => {
                                                    const regions: any = [];
                                                    items.map((item) =>
                                                        regions.push(
                                                            item.value ===
                                                                'france'
                                                                ? 'Toute la France'
                                                                : item.value
                                                        )
                                                    );

                                                    let newE = {
                                                        target: {
                                                            id: 'regions',
                                                            value: regions,
                                                        },
                                                    };
                                                    handlechange(newE);
                                                }}
                                                name="colors"
                                                options={frenchAreas.map(
                                                    (item) => ({
                                                        value:
                                                            item ===
                                                            'Toute la France'
                                                                ? 'france'
                                                                : item,
                                                        label: item,
                                                    })
                                                )}
                                                className="w-full"
                                                classNamePrefix="select"
                                            />
                                        </div>
                                    </div>
                                    {/* channels */}
                                    <div className="mt-3">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Canaux d'acquisition*
                                        </label>

                                        <div className="ml-3 mt-4 grid grid-cols-2 gap-2 xl:grid-cols-3">
                                            {allChannels.map((channel) => (
                                                <div className="col-span-1 flex">
                                                    <Checkbox
                                                        defaultChecked={false}
                                                        id={channel}
                                                        onChange={
                                                            handleChannelChange
                                                        }
                                                    />
                                                    <div className="ml-2">
                                                        <ChannelIcon
                                                            channel={channel}
                                                        />
                                                    </div>
                                                    <p className="ml-1 text-xs">
                                                        {channel}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {/* right side */}
                                <div className="col-span-2 md:col-span-1">
                                    {/* Type */}
                                    <div className="mb-0 mt-4">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Industrie*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <select
                                                id="industry"
                                                className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                onChange={handleIndustryChange}
                                            >
                                                {industriesData.map((item) => (
                                                    <option key={item._id} value={item.name}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Sous-Industrie */}
                                    <div className="mb-0 mt-5">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Sous-Industrie*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <select
                                                id="subIndustry"
                                                className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                onChange={
                                                    handleSubIndustryChange
                                                }
                                            >
                                                {industriesData
                                                    .find(i => i.name === industry)
                                                    ?.subIndustries.map((item: any) => (
                                                        <option
                                                            key={item.name}
                                                            value={item.name}
                                                        >
                                                            {item.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {(industry === 'Autre' ||
                                        subIndustry === 'Autre') && (
                                        <div className="mb-0 ml-2 mt-2">
                                            <label
                                                htmlFor={'others'}
                                                className={`ml-1.5 text-sm font-bold text-navy-700 dark:text-white`}
                                            >
                                                Autre
                                            </label>
                                            <p className="mt-2 text-sm">
                                                Contactez charlotte@leadrs.co
                                                pour ajouter votre industrie sur
                                                Leadrs
                                            </p>
                                        </div>
                                    )}

                                    {/* SSous-sous-Industrie */}
                                    {/* find element in industries[industry] who contain subIndustry */}
                                    {industriesData
                                        .find(i => i.name === industry)
                                        ?.subIndustries.find(
                                            (item: any) => item.name === subIndustry
                                        )?.sub?.length > 0 && (
                                        <div className="mb-0 mt-3">
                                            <label
                                                htmlFor="currency"
                                                className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                            >
                                                Détails sous-industrie*
                                            </label>
                                            <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                                <select
                                                    id="subIndustry"
                                                    className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                    onChange={handlechange}
                                                >
                                                    {/* Find industries[industry] where name === subIndustry */}
                                                    {industriesData
                                                        .find(i => i.name === industry)
                                                        ?.subIndustries.find(
                                                            (item: any) => item.name === subIndustry
                                                        )?.sub?.map(
                                                            (subItem: any) => (
                                                                <option
                                                                    key={subItem}
                                                                    value={subItem}
                                                                >
                                                                    {subItem}
                                                                </option>
                                                            )
                                                        )}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {/* text area */}
                                    {/* <div className="mt-5">
                                        <TextField
                                            label="Votre site web*"
                                            placeholder="Avez vous deja un site internet actif ? Si oui quel CMS utilisez-vous ?"
                                            id="websiteInfo"
                                            onChange={handlechange}
                                            cols={30}
                                            rows={4}
                                        />
                                    </div>
                                    <div className="mt-7">
                                        <TextField
                                            label="Thématique de votre site"
                                            placeholder="Pouvez vous expliquer en quelques phrase la thématique de votre site internet ?"
                                            id="description"
                                            onChange={handlechange}
                                            cols={30}
                                            rows={4}
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        {/* Stepper Two */}
                        <div
                            className={`${
                                steps[currentStep - 1].stepNo === 1 && 'hidden'
                            } h-full w-full rounded-[20px] px-3 pt-7 md:px-8`}
                        >
                            {/* Header */}
                            <h1 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
                                Pricing
                            </h1>
                            {/* Error message */}
                            {error && (
                                <div className="z-10 ml-1 mt-2 items-center font-poppins text-[14px] text-red-500">
                                    {error}.
                                </div>
                            )}
                            {/* inputs */}
                            <div className="mt-10 grid h-full w-full grid-cols-1 gap-3">
                                {/* left side */}
                                <div className="flex gap-3">
                                    <InputField
                                        label="Prix par lead"
                                        placeholder="260"
                                        id="sellerPrice"
                                        type="number"
                                        onChange={handlechange}
                                    />
                                    {/* Seller Offer creation */}
                                    <InputField
                                        label="Quantité de leads (min 40, max 500)"
                                        placeholder="250"
                                        id="weeklyQuantity"
                                        type="number"
                                        onChange={handlechange}
                                    />
                                </div>
                                <div className="col-span-12 mt-3">
                                    <label
                                        htmlFor="currency"
                                        className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                    >
                                        Critères de votre lead
                                    </label>
                                    <div className="ml-3 mt-4 grid grid-cols-12">
                                        {(industriesData
                                            .find(i => i.name === industry)?.fields || [])
                                            .concat([
                                                'Téléphone',
                                                'Email',
                                                'Nom',
                                                'Prénom',
                                            ])
                                            .reverse()
                                            .map((field: string) => (
                                                <div className="col-span-4 mt-2">
                                                    <Checkbox
                                                        defaultChecked={[
                                                            'Téléphone',
                                                            'Nom',
                                                            'Prénom',
                                                        ].includes(field)}
                                                        id={field}
                                                        extra="mt-1"
                                                        onChange={
                                                            handleFieldsChange
                                                        }
                                                    />
                                                    <p>{field}</p>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* navigation button */}
                    <div className="flex justify-end text-center">
                        {steps[currentStep - 1].stepNo === 2 && (
                            <button
                                onClick={() => setCurrentStep(1)}
                                className="mt-5 text-sm"
                            >
                                Retour
                            </button>
                        )}
                        <StepperControl
                            handleClick={handleClick}
                            currentStep={currentStep}
                            steps={steps}
                        />
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default SellerOffer;
